jQuery(function($) {

  function startTime() {
    var days, hours, mins, seconds;
    var now = Date.now();
    var live = new Date("30 Apr 2019 19:15:00");
    if ($(".clock").length > 0) {
      live = new Date($(".clock").attr("data-date"));
    }

    var diff = live.getTime() - now;

    if (diff > 0) {
      days = Math.floor(diff / (1000 * 60 * 60 * 24));
      diff -=  days * (1000 * 60 * 60 * 24);

      hours = Math.floor(diff / (1000 * 60 * 60));
      diff -= hours * (1000 * 60 * 60);

      mins = Math.floor(diff / (1000 * 60));
      diff -= mins * (1000 * 60);

      seconds = Math.floor(diff / (1000));
      diff -= seconds * (1000);
    } else {
      days = 0;
      hours = 0;
      mins = 0;
      seconds = 0;
    }

    $(".clock .days span").text(checkTime(days));
    $(".clock .hours span").text(checkTime(hours));
    $(".clock .minutes span").text(checkTime(mins));
    $(".clock .seconds span").text(checkTime(seconds));

    var t = setTimeout(startTime, 1000);
  }
  function checkTime(i) {
    if (i < 10) {i = "0" + i};  // add zero in front of numbers < 10
    return i;
  }

  var $container = $(".container-box-1700");

  if ($container.length > 0) {
    $container.addClass("landing");
  }

  var slider = tns({
    container: '.landing-slider',
    items: 1,
    slideBy: 'page',
    autoplay: false,
    controlsText: ["<i class='fa fa-angle-left' aria-hidden='true'></i>","<i class='fa fa-angle-right' aria-hidden='true'></i>"]
  });

  $("button[data-controls='prev']").attr("data-aos","fade-right");
  $("button[data-controls='next']").attr("data-aos","fade-left");

  startTime();

  AOS.init({
    once: true
  });

});